import K_PortalWidgetContainer from "../templates/K_PortalWidgetContainer";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PortalWidgetContainerOptions extends ComponentOptions {
    title?: string;
    column?: any;
    widgetType?: any;
    iconClasses?: string;
    Html?: any;
    widgetName?: string;
    bsc?: string;
    style?: string;
}

export class PortalWidgetContainer extends TemplateComponent {

    options: PortalWidgetContainerOptions;
    column: any;
    header: any;
    widgetType: any;
    html: any;

    constructor(options: PortalWidgetContainerOptions) {
        super(K_PortalWidgetContainer, options);
    }

    preRender() {
        const options = this.options;

        options.title = options.title;
        this.column = options.column;
        this.header = options.title;

        if (options.widgetType.CodeNumber.indexOf("Grid") < 0 && options.widgetType.CodeNumber.indexOf("Chart") < 0) {
            options.iconClasses = "disabled";
        }

        options.iconClasses = options.iconClasses || "";
        this.widgetType = options.type;
        this.html = options.Html;
    }

    change(options: PortalWidgetContainerOptions) {

    }

}
